module.exports = "<h2 mat-dialog-title>{{ title }}</h2>\r\n<mat-dialog-content>\r\n  {{ message }}\r\n</mat-dialog-content>\r\n<mat-dialog-actions>\r\n  <button mat-button color=\"primary\" [mat-dialog-close]=\"true\">OK</button>\r\n  <button mat-button [mat-dialog-close]=\"false\">Cancel</button>\r\n</mat-dialog-actions>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/confirm-dialog/confirm-dialog.component.html
// module id = ./src/app/shared/confirm-dialog/confirm-dialog.component.html
// module chunks = main